import TitleBar from '../../../components/TitleBar';
import { useParams } from 'react-router-dom';
import { Footer } from '../../../components/common/Footer';
import { StrategiesTable } from './components';
import { Loading } from '../../../components';
import useBCPMetaData from '../../../hooks/useBCPMetaData';
import FetchError from '../../../components/generic/FetchError';
import BorderedSection from '../../../components/generic/BorderedSection';
import TitleUpdater from '../../../components/common/TitleUpdater';

export default function Strategies() {
  const params = useParams();
  const { locationId } = params;

  const { locationName, loading, error } = useBCPMetaData(locationId!);

  const backPath = `/bcp-landing/location/${locationId}`;

  if (loading) return <Loading />;

  if (error) return <FetchError error={error.message} />;

  return (
    <div>
      <TitleUpdater title={locationName + ' Strategies'} />
      <TitleBar title="BCP Hub" subtitle={'Strategies'} />
      <StrategiesTable locationId={locationId!} locationName={locationName!} />
      <Footer backPath={backPath} />
    </div>
  );
}
